import "./Footer.css";

/**
 *
 * @returns Affichage footer avec logo blanc
 */
function Footer() {
	return (
		<footer>
			<p><strong></strong></p>
			<p> © 2023. All rights reserved</p>
		</footer>
	);
}

export default Footer;
